import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLogService } from "../../services/log.service";

interface LocationImpressumDialogModalData {
  impressumHtml: string | (() => string);
}

@Component({
  selector: "locationImpressumDialog",
  templateUrl: "./locationImpressumDialog.component.html",
  styleUrls: ["./locationImpressumDialog.component.scss"],
})

export class LocationImpressumDialogComponent implements OnInit {
  constructor(
    public bottomSheetRef: MatBottomSheetRef<LocationImpressumDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalImpressumData: LocationImpressumDialogModalData
    , private _coreLogService: CoreLogService
    , private _changeDetectorRef: ChangeDetectorRef) { }

  private pushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error(
        "locationImpressumDialogComponent.PushChanges",
        "_changeDetectorRef.detectChanges (catch)",
        e
      );
    }
  }

  ngOnInit() {
    const me = this;
  }
}